// Phase G — Look up today's win_acca share card (if any) for OG meta tags.
//
// Returns the most recent share-card row whose payload acca_date matches
// today, kind='win_acca'. Used by DailyAccaPage to set
// <meta property="og:image"> dynamically. When today's acca has not
// landed yet (most days), returns null and the page falls back to the
// generic /api/og/share-card image (no card_id → branded fallback).
//
// RLS: anon SELECT is allowed for rows generated within the last 7 days
// (Phase G migration). Safe to call from public surfaces.

import { useEffect, useMemo, useState } from "react";
import { getBrowserClient } from "../supabase/browser.ts";

export function useTodayShareCard(): { cardId: string | null; loading: boolean } {
  const supabase = useMemo(() => getBrowserClient(), []);
  const [cardId, setCardId] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    const today = new Date().toISOString().slice(0, 10);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const sb = supabase as any;
    void sb
      .from("free_tier_share_cards")
      .select("id, card_kind, card_payload, generated_at")
      .eq("card_kind", "win_acca")
      .order("generated_at", { ascending: false })
      .limit(5)
      .then(({ data }: { data: Array<Record<string, unknown>> | null }) => {
        if (cancelled) return;
        const row = (data ?? []).find((r) => {
          const p = (r["card_payload"] as Record<string, unknown> | null) ?? null;
          return p && typeof p["acca_date"] === "string" && p["acca_date"] === today;
        });
        setCardId(row ? String(row["id"]) : null);
        setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [supabase]);

  return { cardId, loading };
}
